import axios from 'axios';
import { FUEL_TYPE_MAP, STATE_MAPPER } from '../../components/docs/constants';
import { VEHICLE_TYPE_MAPPER } from '../../components/fees/contants';
import JSZip from 'jszip';

const SERVER_URL = process.env.REACT_APP_API_URL;

export const Api = {
  getCsrfToken: async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/get-csrf-token`, {
        withCredentials: true,
      });
      return response.data.csrf_token;
    } catch (e) {
      console.error('Error fetching CSRF token:', e);
      throw new Error('Failed to get CSRF token.');
    }
  },


  submitDoc: async (data) => {
    try {
      const dateFormater = (date) => {
        const ary = date.split('-');
        return(`${ary[1]}/${ary[2]}/${ary[0]}`)
      }
      const RStateMapperAry = Object
        .entries(STATE_MAPPER)
        .map(([key, value]) => [value, key]);

      const RStateMapper = Object.fromEntries(RStateMapperAry)
      const payload = {
        DealerId: '01',
        City: data.city,
        County: data.country,
        State: RStateMapper[data.state],
        Zipcode: data.zipCode,
        OutsideCityLimits: data.outSideCityLimit ? 'Yes' : 'No', // Not in old UI
        VehicleType: VEHICLE_TYPE_MAPPER[data.vehicleType],
        NewUsed: data.condition,
        Usertype: "",
        VYear: data.modelYear,
        Make: data.make,
        Model: data.model,
        RegistrationMonths: data.registrationMonths,
        VehicleBodyStyle: data.bodyStyle,
        NumberofAxles: data.numberOfAxles,
        NumberOfTires: data.numberOfTires,
        FuelType: FUEL_TYPE_MAP[data.fuelType],
        Cylinders: data.cylinders,
        Odometer: data.odometer,
        RimSize: data.rimSize,
        Color: data.color,
        Weight: data.vehicleWeight,
        GVW: data.gvw,
        MPG: data.mpg,
        HP: data.horsepower,
        MSRP: data.msrp,
        VIN: data.vinCode,
        DriverCategory: data.driverCategory,
        TransType: data.transactionType,
        TransDt: dateFormater(data.transactionDate),
        uploadeddate: dateFormater(data.uploadDate),
        PlateType: data.plateType,
        PlateNumberField: data.plateNumber,
        TotalPrice: data.basePrice,
        DocumentFees: data.docsFees,
        AddOnField: data.additionalFees,
        ExtendedWarrantiesField: data.extendedWarranties,
        InsurancePackages: data.insurancePackages,
        ProtectionPackageField: data.protectionPackages,
        Military: data.military ? 'Yes' : 'No',
        TransferingPlates: data.plateTransfer ? 'Yes' : 'No',
        Lien: data.lien ? 'Yes' : 'No',
        TheftProtectionField: data.theftProtection,
        FBFirstName: data.buyerFirstName,
        FBMiddleName: data.buyerMiddleName,
        FBLastName: data.buyerLastName,
        FBCompany: data.buyerCompanyName,
        FBAddress: data.buyerAddressLine1,
        FBAddress2: data.buyerAddressLine2,
        FBCity: data.buyerCity,
        FBState: data.buyerState,
        FBZip: data.buyerZip,
        FBDOB: data.buyerDob,
        FBSSN: data.buyerSsn,
        FBDLNumber: data.buyerLicenseNumber,
        FBDLState: data.buyerLicenseState,
        SBFirstName: data.secondBuyerFirstName,
        SBMiddleName: data.secondBuyerMiddleName,
        SBLastName: data.secondBuyerLastName,
        SBCompany: data.secondBuyerCompanyName,
        SBAddress: data.secondBuyerAddressLine1,
        SBAddress2: data.secondBuyerAddressLine2,
        SBCity: data.secondBuyerCity,
        SBState: data.secondBuyerState,
        SBZip: data.secondBuyerZip,
        SBDOB: data.secondBuyerDob,
        SBSSN: data.secondBuyerSsn,
        SBDLNumber: data.secondBuyerLicenseNumber,
        SBDLState: data.secondBuyerLicenseState,
        FSFirstName: data.sellerFirstName,
        FSMiddleName: data.sellerMiddleName,
        FSLastName: data.sellerLastName,
        FSCompany: data.sellerCompany,
        FSAddress: data.sellerAddress,
        FSCity: data.sellerCity,
        FSState: data.sellerState,
        FSZip: data.sellerZip,
        FSDealerNumber: data.sellerDealerNumber,
        SSFirstName: data.secondSellerFirstName,
        SSMiddleName: data.secondSellerMiddleName,
        SSLastName: data.secondSellerLastName,
        SSCompany: data.secondSellerCompany,
        SSAddress: data.secondSellerAddress,
        SSCity: data.secondSellerCity,
        SSState: data.secondSellerState,
        SSZip: data.secondSellerZip,
        SSDealerNumber: data.secondSellerDealerNumber,
        InsuranceCompany: data.insuranceCompany,
        InsuranceDate: data.insuranceDate,
        InsuranceExpiryDate: data.insuranceExpirationDate,
        InsuranceNumber: data.insurancePolicyNumber,
        LienholderCompany: data.lienholderCompanyName,
        LienholderAddress: data.lienholderAddress,
        LienholderAddress2: data.lienholderAddress2,
        LHCity: data.lienholderCity,
        LHState: data.lienholderState,
        LHZIP: data.lienholderZip,
        LienholderFederalTaxId: data.lienholderFederalTaxId,
        LienholderStateTaxID: data.lienholderStateTaxId,
        LHELTName: data.lienholderEltName,
        LHELTID: data.lienholderEltId,
        LHELTAddress: data.lienholderEltAddress,
      };

      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/docs-api-callV2`, payload, {
        headers: {
          'X-CSRFToken': csrfToken,
        },
        withCredentials: true
      });

      return response;
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.message || e?.response?.data?.error || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },

  submitRefiDoc: async (data) => {
    try {
      const dateFormater = (date) => {
        const ary = date.split('-');
        return(`${ary[1]}/${ary[2]}/${ary[0]}`)
      }

      const getVinIndexMap = (vinNumber) => {
        const sanitizedVin = /^[A-HJ-NPR-Z0-9]{17}$/i.test(String(vinNumber).trim())
          ? String(vinNumber).trim()
          : '00000000000000000';

        const vinCharacters = sanitizedVin.split('');

        const vinIndexMap = {};

        vinCharacters.forEach((char, index) => {
          vinIndexMap[`vin_${index}`] = char;
        });

        return vinIndexMap;
      }

      const getOdometerIndexMap = (odometerValue) => {
        const value = odometerValue ? String(odometerValue).trim() : '';
        const odometerDigits = value? value.split('') : '';

        const odometerIndexMap = {};

        if (odometerDigits) {
          odometerDigits.forEach((digit, index) => {
            odometerIndexMap[`odometer_${index}`] = digit;
          });
        }

        return odometerIndexMap;
      };

      const RStateMapperAry = Object
        .entries(STATE_MAPPER)
        .map(([key, value]) => [value, key]);

      const RStateMapper = Object.fromEntries(RStateMapperAry)
      const payload = {
        City: data.city,
        County: data.country,
        State: RStateMapper[data.state],
        Zipcode: data.zipCode,
        OutsideCityLimits: data.outSideCityLimit ? 'Yes' : 'No',
        VehicleType: data.vehicleType,
        NewUsed: data.condition,
        VYear: data.modelYear,
        Make: data.make,
        Model: data.model,
        RegistrationMonths: data.registrationMonths,
        VehicleBodyStyle: data.bodyStyle,
        NumberofAxles: data.numberOfAxles,
        NumberOfTires: data.numberOfTires,
        FuelType: data.fuelType,
        Cylinders: data.cylinders,
        Odometer: data.odometer,
        odometerIndexMap: getOdometerIndexMap(data.odometer),
        RimSize: data.rimSize,
        Color: data.color,
        Weight: data.vehicleWeight,
        GVW: data.gvw,
        MPG: data.mpg,
        HP: data.horsepower,
        MSRP: data.msrp,
        VIN: data.vinCode,
        vinIndexMap: getVinIndexMap(data.vinCode),
        TransType: data.transactionType,
        TransDt: dateFormater(data.transactionDate),
        uploadeddate: dateFormater(data.uploadDate),
        DriverCategory: data.driverCategory,
        PlateType: data.plateType,
        PlateNum: data.plateNumber,
        TotalPrice: data.basePrice,
        DocumentFees: data.docsFees,
        AddOnField: data.additionalFees,
        ExtendedWarrantiesField: data.extendedWarranties,
        InsurancePackages: data.insurancePackages,
        ProtectionPackageField: data.protectionPackages,
        Military: data.military ? 'Yes' : 'No',
        TransferingPlates: data.plateTransfer ? 'Yes' : 'No',
        Lien: data.lien ? 'Yes' : 'No',
        TheftProtectionField: data.theftProtection,
        FOFirstName: data.ownerFirstName,
        FOMiddleName: data.ownerMiddleName,
        FOLastName: data.ownerLastName,
        FOPhone: data.ownerPhoneNumber,
        FOCompany: data.ownerCompanyName,
        FOAddress: data.ownerAddressLine1,
        FOAddress2: data.ownerAddressLine2,
        FOCity: data.ownerCity,
        FOState: data.ownerState,
        FOCounty: data.ownerCountry,
        FOZip: data.ownerZip,
        FODOB: data.ownerDob,
        FOSSN: data.ownerSsn,
        FODLNumber: data.ownerLicenseNumber,
        FODLState: data.ownerLicenseState,
        SOFirstName: data.secondOwnerFirstName,
        SOMiddleName: data.secondOwnerMiddleName,
        SOLastName: data.secondOwnerLastName,
        SOPhone: data.secondOwnerPhoneNumber,
        SOCompany: data.secondOwnerCompanyName,
        SOAddress: data.secondOwnerAddressLine1,
        SOAddress2: data.secondOwnerAddressLine2,
        SOCity: data.secondOwnerCity,
        SOState: data.secondOwnerState,
        SOCounty: data.secondOwnerCountry,
        SOZip: data.secondOwnerZip,
        SODOB: data.secondOwnerDob,
        SOSSN: data.secondOwnerSsn,
        SODLNumber: data.secondOwnerLicenseNumber,
        SODLState: data.secondOwnerLicenseState,
        LienholderCompany: data.lienholderCompanyName,
        LienholderAddress: data.lienholderAddress,
        LienholderAddress2: data.lienholderAddress2,
        LHCity: data.lienholderCity,
        LHState: data.lienholderState,
        LHZIP: data.lienholderZip,
        LienholderFederalTaxId: data.lienholderFederalTaxId,
        LienholderStateTaxID: data.lienholderStateTaxId,
        LHELTName: data.lienholderEltName,
        LHELTID: data.lienholderEltId,
        LHELTAddress: data.lienholderEltAddress,
        Usertype: "",
        num_owners: (data.ownerFirstName && data.secondOwnerFirstName) ? "2" : "1",
      };

      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/refi-docs-api-callV2`, payload, {
        headers: {
          'X-CSRFToken': csrfToken,
        },
        withCredentials: true
      });

      return response;
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.message || e?.response?.data?.error || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },

  downloadAll: async (data, pdfBlob) => {
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/download_files`, data, {
        headers: {
          'X-CSRFToken': csrfToken,
        },
        withCredentials: true,
        responseType: 'blob',
      });

      if (response.status === 200) {
        const zipBlobFromBackend = response.data;

        const zip = await JSZip.loadAsync(zipBlobFromBackend);
        zip.file(`${data.get('transaction_id')}.pdf`, pdfBlob);

        const updatedZipBlob = await zip.generateAsync({ type: 'blob' });

        // Trigger download
        const url = window.URL.createObjectURL(updatedZipBlob);
        const a = document.createElement('a');
        a.href = url;

        a.download = `${data.get('transaction_id') || 'files'}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return { status: 200 };
      }
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.message || e?.response?.data?.error || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },

  getLienHolderInfo: async (data) => {
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/get_lienholder_info`, data, {
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'application/json'
        },
        withCredentials: true,
      });

      if (response.status === 200) {
        return response;
      }
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.message || e?.response?.data?.error || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },
};
